import Image, { IImageProps } from 'components/image';
import { FC } from 'react';
import { genImageAltText } from 'utils/genImageAltText';

interface IProps extends IImageProps {
  className?: string;
}

const ImageResponsive: FC<IProps> = ({ src, alt, className = '', ...props }) => {
  return (
    <Image
      {...props}
      src={src}
      alt={alt ? genImageAltText(alt) : ''}
      className={['absolute w-full h-full left-0 top-0 object-cover', className].join(' ')}
    />
  );
};

export default ImageResponsive;
